// @flow
import styled from "styled-components";

export const Container = styled.div`
    background-color: #fff;
    padding: 10px;
    margin-top: 20px;
    border-top: 1px solid #dddfe2;
    border-bottom: 1px solid #dddfe2;
`;

export const Title = styled.div`
    display: block;
    padding-bottom: 10px;
    opacity: 1;
    font-size: 14px;
`;

export const Button = styled.a`
    width: 10%;
    min-width: 50px;
    opacity: 0.5;
    cursor: pointer;
    margin-right: 15px;
    text-decoration: none;
    display: inline;
    line-height: 30px;
    vertical-align: middle;

    &:hover {
        opacity: 1;
    }

    & > div,
    svg {
        line-height: 30px;
        vertical-align: middle;
    }
`;

export const ButtonText = styled.div`
    font-size: small;
    display: inline;
`;

export const JournalButton = Button.extend`
    color: #03a9f4;
`;
export const PhotoButton = Button.extend`
    color: #8bc34a;
`;
export const MovieButton = Button.extend`
    color: #9c27b0;
`;
export const MapButton = Button.extend`
    color: #f44336;
`;



// WEBPACK FOOTER //
// ./src/update-panel/styled.js